'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: 100%;\n  min-width: 350px;\n  font-family: \'Avenir-Next_Demi\', \'HelveticaNeue-Medium\', \'Helvetica Neue Medium\', \'Helvetica Neue\', Helvetica, Arial, \'Lucida Grande\', sans-serif;\n  border-collapse: collapse;\n\n  thead {\n    text-align: ', ';\n    tr {\n      background-color: #f2f6f9;\n      border-radius: 6px;\n      border-color: transparent;\n    }\n\n    th {\n      color: #8f9da8;\n      font-size: 14px;\n      font-weight: 400;\n      letter-spacing: -0.32px;\n      line-height: 19px;\n      ', '\n\n      &:first-child {\n        border-top-left-radius: 6px;\n        border-bottom-left-radius: 6px;\n      }\n\n      &:last-child {\n        border-top-right-radius: 6px;\n        border-bottom-right-radius: 6px;\n      }\n    }\n  }\n\n  tbody {\n    text-align: ', ';\n    tr {\n      &:nth-child(even) {\n        background-color: ', ';\n      }\n\n      &:nth-child(odd) {\n        background-color: white;\n      }\n    }\n  }\n\n  th, td {\n    padding: ', ';\n    height: ', ';\n  }\n\n  td {\n    &:nth-child(even) {\n      ', '\n    }\n    color: #3a4951;\n    font-size: 12px;\n    font-weight: 500;\n    letter-spacing: -0.1px;\n    line-height: 16px;\n  }\n\n  tr {\n    background-color: white;\n    border-bottom: 1px solid #DBE2E8;\n  }\n'], ['\n  width: 100%;\n  min-width: 350px;\n  font-family: \'Avenir-Next_Demi\', \'HelveticaNeue-Medium\', \'Helvetica Neue Medium\', \'Helvetica Neue\', Helvetica, Arial, \'Lucida Grande\', sans-serif;\n  border-collapse: collapse;\n\n  thead {\n    text-align: ', ';\n    tr {\n      background-color: #f2f6f9;\n      border-radius: 6px;\n      border-color: transparent;\n    }\n\n    th {\n      color: #8f9da8;\n      font-size: 14px;\n      font-weight: 400;\n      letter-spacing: -0.32px;\n      line-height: 19px;\n      ', '\n\n      &:first-child {\n        border-top-left-radius: 6px;\n        border-bottom-left-radius: 6px;\n      }\n\n      &:last-child {\n        border-top-right-radius: 6px;\n        border-bottom-right-radius: 6px;\n      }\n    }\n  }\n\n  tbody {\n    text-align: ', ';\n    tr {\n      &:nth-child(even) {\n        background-color: ', ';\n      }\n\n      &:nth-child(odd) {\n        background-color: white;\n      }\n    }\n  }\n\n  th, td {\n    padding: ', ';\n    height: ', ';\n  }\n\n  td {\n    &:nth-child(even) {\n      ', '\n    }\n    color: #3a4951;\n    font-size: 12px;\n    font-weight: 500;\n    letter-spacing: -0.1px;\n    line-height: 16px;\n  }\n\n  tr {\n    background-color: white;\n    border-bottom: 1px solid #DBE2E8;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var StyledTable = _styledComponents2.default.table(_templateObject, function (_ref) {
  var alignHeader = _ref.alignHeader;
  return alignHeader || 'center';
}, function (_ref2) {
  var compact = _ref2.compact;
  return !compact && 'vertical-align: top;';
}, function (_ref3) {
  var alignBody = _ref3.alignBody;
  return alignBody || 'left';
}, function (props) {
  return props.striped ? '#f2f6f9' : 'white';
}, function (_ref4) {
  var compact = _ref4.compact;
  return compact ? '0 15px' : '15px';
}, function (_ref5) {
  var compact = _ref5.compact;
  return compact ? '32px' : '46px';
}, function (_ref6) {
  var vertStriped = _ref6.vertStriped;
  return vertStriped && 'background-color: #f2f6f9;';
});

exports.default = StyledTable;
//# sourceMappingURL=StyledTable.js.map


//////////////////
// WEBPACK FOOTER
// ../table/lib/StyledTable.js
// module id = 657
// module chunks = 0